// extracted by mini-css-extract-plugin
export default {"container":"ClinicCard_container__jeP+R","doctorsSection":"ClinicCard_doctorsSection__n0Y-G"};